import {Command} from "./Command";


export class BulkPropertyChangeCommand extends Command {
    constructor(component) {
        super();
        this._component = component
        this._changes = []
    }

    get hasChanges () {
        return this._changes.length > 0;
    }

    get fbNode() {
        return this._component.fbNode
    }

    get firebaseRef() {
        return this._component.firebaseRef()
    }

    async execute() {
        for (let i = 0; i < this._changes.length; i++) {
            const command = this._changes[i];
            await command.execute()
        }
    }

    async unExecute() {
        for (let i = 0; i < this._changes.length; i++) {
            const command = this._changes[i];
            await command.unExecute()
        }
    }

    addCommand(command) {
        if (command.hasChanges) {
            this._changes.push(command)
        }
    }
}